import _ from 'underscore';
import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import { siteMapPropType } from '@bingads-webui-campaign-react/with-site-map';
import { SimpleSummaryBar } from '@bingads-webui-campaign-react/summary-bar';

const Loader = (props) => {
  const {
    siteMap,
    breadCrumbText,
    backButtonText,
    backButtonUrl,
    updateAvailability,
    isVisible,
    ...others
  } = props;

  const selectedParent = _.findWhere(siteMap, { selected: true });

  useEffect(() => {
    updateAvailability(!_.isEmpty(selectedParent));
  });

  return isVisible
    ? (
      <SimpleSummaryBar
        selectedParent={selectedParent}
        breadCrumbText={breadCrumbText}
        backButtonText={backButtonText}
        backButtonUrl={backButtonUrl}
        {...others}
      />)
    : null;
};

Loader.propTypes = {
  siteMap: siteMapPropType.isRequired,
  breadCrumbText: PropTypes.string,
  backButtonText: PropTypes.string,
  backButtonUrl: PropTypes.string,
  updateAvailability: PropTypes.func,
  isVisible: PropTypes.bool,
};

Loader.defaultProps = {
  breadCrumbText: null,
  backButtonText: null,
  backButtonUrl: null,
  updateAvailability: _.noop,
  isVisible: false,
};

export const SimpleSummaryBarLoader = React.memo(Loader);
